"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const index_1 = require("../../../../index");
const styles_1 = require("./styles");
var Months;
(function (Months) {
    Months[Months["January"] = 0] = "January";
    Months[Months["February"] = 1] = "February";
    Months[Months["March"] = 2] = "March";
    Months[Months["April"] = 3] = "April";
    Months[Months["May"] = 4] = "May";
    Months[Months["June"] = 5] = "June";
    Months[Months["July"] = 6] = "July";
    Months[Months["August"] = 7] = "August";
    Months[Months["September"] = 8] = "September";
    Months[Months["October"] = 9] = "October";
    Months[Months["November"] = 10] = "November";
    Months[Months["December"] = 11] = "December";
})(Months || (Months = {}));
const { ArrowLeft, ArrowRight, ArrowDown } = index_1.icon;
const CustomHeader = ({ date, changeMonth, changeYear, decreaseMonth, increaseMonth, maxYear, minYear, prevMonthButtonDisabled: isPrevMonthButtonDisabled, nextMonthButtonDisabled: isNextMonthButtonDisabled }) => {
    const theme = (0, styled_components_1.useTheme)();
    const years = Array.from({ length: maxYear - minYear + 1 }, (_, i) => i + minYear);
    const [isMonthsListOpen, setIsMonthsListOpen] = (0, react_1.useState)(false);
    const [isYearsListOpen, setIsYearsListOpen] = (0, react_1.useState)(false);
    const handleOpenMonth = () => {
        setIsMonthsListOpen(!isMonthsListOpen);
        setIsYearsListOpen(false);
    };
    const handleOpenYear = () => {
        setIsYearsListOpen(!isYearsListOpen);
        setIsMonthsListOpen(false);
    };
    const handleChangeMonth = (changeMonth, month) => {
        changeMonth(month);
        setIsMonthsListOpen(false);
    };
    const handleChangeYear = (changeYear, year) => {
        changeYear(year);
        setIsYearsListOpen(false);
        setIsMonthsListOpen(true);
    };
    const handlerOnClick = () => {
        setIsYearsListOpen(!isYearsListOpen);
        if (isMonthsListOpen) {
            setIsMonthsListOpen(false);
            setIsYearsListOpen(false);
        }
    };
    return (react_1.default.createElement(styles_1.StyledCustomHeader, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("button", { "data-islistopen": isMonthsListOpen, onClick: handleOpenMonth }, Months[date === null || date === void 0 ? void 0 : date.getMonth()]),
            isMonthsListOpen && (react_1.default.createElement(styles_1.StyledHeaderLists, null, Object.keys(Months)
                .filter((month) => isNaN(Number(month)))
                .map((month, index) => (react_1.default.createElement("div", { "data-selected": Months[date === null || date === void 0 ? void 0 : date.getMonth()] === month, key: month, onClick: () => handleChangeMonth(changeMonth, index) }, month.substring(0, 3)))))),
            react_1.default.createElement("button", { "data-islistopen": isYearsListOpen, onClick: handleOpenYear }, date === null || date === void 0 ? void 0 : date.getFullYear()),
            isYearsListOpen && (react_1.default.createElement(styles_1.StyledHeaderLists, null, years.reverse().map(year => (react_1.default.createElement("div", { "data-selected": (date === null || date === void 0 ? void 0 : date.getFullYear()) === year, key: year, onClick: () => handleChangeYear(changeYear, year) }, year))))),
            react_1.default.createElement(styles_1.StyledWrapButtonIcon, { "data-rotate": isMonthsListOpen || isYearsListOpen, onClick: handlerOnClick },
                react_1.default.createElement(ArrowDown, { color: theme.neutral.main }))),
        react_1.default.createElement(styles_1.StyledWrapButtonsArrows, null,
            react_1.default.createElement("button", { onClick: decreaseMonth, disabled: isPrevMonthButtonDisabled },
                react_1.default.createElement(ArrowLeft, { color: theme.neutral.light })),
            react_1.default.createElement("button", { onClick: increaseMonth, disabled: isNextMonthButtonDisabled },
                react_1.default.createElement(ArrowRight, { color: theme.neutral.light })))));
};
exports.default = CustomHeader;
